module.exports = "<h3><span *ngIf=\"countValue !== undefined\" [ngClass]=\"{'green': countValue === 0 && changeColorBasedOnCount, 'black': !changeColorBasedOnCount}\">{{ countValue }}</span>{{ title }}</h3>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/title/title.component.html
// module id = ../../../../../src/app/shared/title/title.component.html
// module chunks = main